<template>
  <div class="whatido">

    <!-- Header Area Start -->
    <AppHeader></AppHeader>

    <!-- Contents Area Start -->
    <div class="contents">

      <h2>WhatIdo</h2>

      <ul>
        <li>
          <div class="card">
            <div class="card-content center-align">
              <i class="xi-desktop"></i>
              <h3>GRAPHIC DESIGN</h3>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt,</p>
            </div>
          </div>
        </li>
        <li>
          <div class="card">
            <div class="card-content center-align">
              <i class="xi-codepen"></i>
              <h3>APP DESIGN</h3>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt,</p>
            </div>
          </div>
        </li>
        <li>
          <div class="card">
            <div class="card-content center-align">
              <i class="xi-devices"></i>
              <h3>RESPONSIVE DESIGN</h3>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt,</p>
            </div>
          </div>
        </li>
        <li>
          <div class="card">
            <div class="card-content center-align">
              <i class="xi-code"></i>
              <h3>WEB APP DESIGN</h3>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt,</p>
            </div>
          </div>
        </li>
      </ul>

    </div>

    <!-- Footer Area Start -->
    <AppFooter></AppFooter>

  </div>
</template>

<script>
import AppHeader from './component/Header.vue';
import AppFooter from './component/Footer.vue';

export default {
  name: "Whatido",
  components: {
    AppHeader,
    AppFooter
  },
  mounted() {
    this.menuAct4();
  },
  methods: {
    menuAct4(){
      $('.footer a').removeClass('menu-act');
      $('.footer li:nth-child(4) a').addClass('menu-act');
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../sass/partials/_variable.scss';

  .whatido{

    li{
      margin-bottom: 21px;

      .card{
        padding: 21px 15px;
        border: 1px solid #e7e7e7;
        border-radius: 5px;
        cursor: pointer;

        i{
          font-size: 4.5rem;
          color: $p-bg3;
          margin-bottom: 30px;
        }

        h3{
          margin: 0 0 21px;
          font: 600 1.8rem $ff4;
          color: $typo2;
        }

        p{ font-size: 1.6rem; }

        -webkit-transition: all ease 0.6s;
        -moz-transition: all ease 0.6s;
        -o-transition: all ease 0.6s;
        transition: all ease 0.6s;

        &:hover{
          -webkit-transform: scale(1.03);
          -moz-transform: scale(1.03);
          -o-transform: scale(1.03);
          transform: scale(1.03);
        }
      }
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/Whatido.vue